<template lang="pug">
  el-row
    div.custom-div
      CardEdital(
        :tipoEdital='this.editalGeomensor.tipoEdital',
        :abertura='this.editalGeomensor.abertura',
        :encerramento='this.editalGeomensor.encerramento',
        :edital='this.editalGeomensor.numeroEdital',
        :situacao='this.editalGeomensor.situacao',
        :navigateRoute='() => navigateNewRoute("GEOMENSOR")',
        :download='() => downloadEdital("GEOMENSOR")'
        ).custom-spacing
      CardEdital(
        :tipoEdital='this.editalVistoriador.tipoEdital',
        :abertura='this.editalVistoriador.abertura',
        :encerramento='this.editalVistoriador.encerramento',
        :edital='this.editalVistoriador.numeroEdital',
        :situacao='this.editalVistoriador.situacao',
        :navigateRoute='() => navigateNewRoute("VISTORIADOR")',
        :download='() => downloadEdital("VISTORIADOR")'
          )
</template>

<script>
import CardEdital from '@/components/CardEdital'
import { getEdital, downloadEditalById } from '@/services/editalService';
import util from '@/utils/utils'

export default {
  data () {
    return {
      editalGeomensor: {
        id: '',
        tipoEdital: 'GEOMENSOR',
        numeroEdital: '-',
        abertura: '-',
        encerramento: '-',
        edital: '-',
        anexoNome: '',
        situacao: '-'
      },
      editalVistoriador: {
        id: '',
        tipoEdital: 'VISTORIADOR',
        numeroEdital: '-',
        abertura: '-',
        encerramento: '-',
        edital: '-',
        anexoNome: '',
        situacao: '-'
      },
    }
  },
  methods: {
    navigateNewRoute (tipo) {
      if (tipo === 'GEOMENSOR') {
        this.goTo('credenciados/cadastro', { idEdital: this.editalGeomensor.id })
      } else {
        this.goTo('credenciados/cadastro', { idEdital: this.editalVistoriador.id })
      }
    },
    async downloadEdital (tipo) {
      if (tipo) {
        let idEdital = this.editalVistoriador.id;

        if (tipo === 'GEOMENSOR') {
          idEdital = this.editalGeomensor.id;
        }

        let urlBase = process.env.VUE_APP_ROOT_URL;

        if (idEdital) {
          window.open(urlBase + "/publico/edital/baixar?idEdital=" + idEdital, "_blank");
        }
      }
    },

    async downloadEdital_ (tipo) {
      const fileLink = document.createElement('a');
      if (tipo === 'GEOMENSOR') {
        const arquivo = await downloadEditalById(this.editalGeomensor.id);
        if (arquivo) {
          const fileURL = new Blob([arquivo]);
          fileLink.setAttribute('download', this.editalGeomensor.anexoNome);
          fileLink.href = window.URL.createObjectURL(fileURL);
          document.body.appendChild(fileLink);
          fileLink.click();
        }
      } else {
        const arquivo = await downloadEditalById(this.editalVistoriador.id);
        if (arquivo) {
          const fileURL = new Blob([arquivo]);
          fileLink.setAttribute('download', this.editalVistoriador.anexoNome);
          fileLink.href = window.URL.createObjectURL(fileURL);
          document.body.appendChild(fileLink);
          fileLink.click();
        }
      }
      return Promise.resolve();
    },
    goTo (route, params) {
      this.$router.push({
        name: route,
        params: params,
      })
    },
    async loadEditais() {
      let editalGeo = await getEdital();
      if (editalGeo[1]) {
        this.editalGeomensor.anexoNome = editalGeo[1].anexo.nome
        this.editalGeomensor.tipoEdital = editalGeo[1].tipoEdital
        this.editalGeomensor.numeroEdital = editalGeo[1].numero
        this.editalGeomensor.abertura = util.formatDate(editalGeo[1].dataInicio)
        this.editalGeomensor.encerramento = util.formatDate(editalGeo[1].dataFim)
        this.editalGeomensor.id = editalGeo[1].id
        if (Date.now() < editalGeo[1].dataFim) {
          this.editalGeomensor.situacao = 'Aberto'
        } else {
          this.editalGeomensor.situacao = 'Encerrado'
        }
      }
      if (editalGeo[0]) {
        this.editalVistoriador.anexoNome = editalGeo[0].anexo.nome
        this.editalVistoriador.tipoEdital = editalGeo[0].tipoEdital
        this.editalVistoriador.numeroEdital = editalGeo[0].numero
        this.editalVistoriador.abertura = util.formatDate(editalGeo[0].dataInicio)
        this.editalVistoriador.encerramento = util.formatDate(editalGeo[0].dataFim)
        this.editalVistoriador.id = editalGeo[0].id
        if (Date.now() < editalGeo[0].dataFim) {
          this.editalVistoriador.situacao = 'Aberto'
        } else {
          this.editalVistoriador.situacao = 'Encerrado'
        }
      }
    }
  },
  components: {
    CardEdital
  },
  async created () {
    this.loadEditais()
  },
}
</script>

<style scoped lang="scss">
@import "@/assets/styles/_variables.scss";

.custom-div{
  display: flex;
  justify-content: center;
  width: 100%;
}

.custom-spacing {
  padding-right: 50px;
}

.el-main {
  min-height: 0vh !important;
}

@media (max-width: 1256px) {
  .custom-div {
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  .custom-spacing {
    padding-bottom: 20px;
  }
}

</style>
